
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<MealChip>({})
export default class MealChip extends Vue {
	@Prop({ type: Object, required: true }) private item!: MenuItem;
	@Prop({ type: Boolean, required: false, default: false }) private selected!: boolean;

	private get isUnavailable(): boolean {
		return !!(this.item.sold_out || this.item.unavailable);
	}

	private onToggle(): void {
		if (this.isUnavailable) {
			return;
		}
		this.$emit('toggle', this.item);
	}
}
